import React from 'react';
import { useSkuSelector } from '../hooks/useSkuSelector';

type SkuSelectorContainerProps = { children: React.ReactNode };

const SkuSelectorContainer = ({ children }: SkuSelectorContainerProps) => {
	const { blockClass, componentId, handles, prodSum } = useSkuSelector();

	const renderClass = () => blockClass && `vtex-store-components-3-x-skuSelectorContainer--${blockClass}`;
	return (
		<div
			data-selection={componentId}
			className={`${prodSum ? handles.skuSelectorContainer : ''} skuSelectorContainer skuSelectorContainer--${blockClass} vtex-store-components-3-x-skuSelectorContainer ${renderClass()}`}
		>
			{children}
		</div>
	);
};

export default SkuSelectorContainer;
